"use client"

import type React from "react"
import { memo } from "react"
import type { User, UserMenuAction } from "../../../types/header"
import UserAvatar from "./UserAvatar"
import UserMenuDropdown from "./UserMenuDropdown"

interface UserProfileProps {
  user: User
  isMenuOpen: boolean
  onToggleMenu: () => void
  menuActions: UserMenuAction[]
  menuRef: React.RefObject<HTMLDivElement | null>
}

const UserProfile: React.FC<UserProfileProps> = memo(({ user, isMenuOpen, onToggleMenu, menuActions, menuRef }) => (
  <div className="user-profile-section" ref={menuRef}>
    <button
      className="user-profile-button"
      onClick={onToggleMenu}
      title="User Menu"
      aria-expanded={isMenuOpen}
      aria-haspopup="true"
    >
      <UserAvatar />
      <div className="user-info">
        <span className="user-name">
          {user.first_name} {user.last_name}
        </span>
        <span className="user-email">{user.email}</span>
      </div>
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className={`chevron ${isMenuOpen ? "rotated" : ""}`}
      >
        <polyline points="6,9 12,15 18,9" />
      </svg>
    </button>

    <UserMenuDropdown user={user} actions={menuActions} isOpen={isMenuOpen} />
  </div>
))

UserProfile.displayName = "UserProfile"

export default UserProfile
